"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getGradeFromScoreAndCalculator_1 = __importDefault(require("../getGradeFromScoreAndCalculator"));
const GradingMethodType_1 = __importDefault(require("../GradingMethodType"));
const PassStatus_1 = __importDefault(require("../PassStatus"));
const calcGrade = (gradingMethod, isScoreEnabled, fail, grades, gradingCalculators, opScore, completed
// eslint-disable-next-line max-params
) => {
    let grade;
    let passStatus = PassStatus_1.default.UNDETERMINED;
    if (!completed)
        return { grade: null, passStatus };
    const percent = (opScore.total / opScore.max) * 100;
    // Grade - PASSFAIL
    if ((gradingMethod === null || gradingMethod === void 0 ? void 0 : gradingMethod.gradingMethodType) === GradingMethodType_1.default.PASSFAIL) {
        // With Scoring
        if (isScoreEnabled) {
            passStatus = percent >= gradingMethod.minScore ? PassStatus_1.default.PASS : PassStatus_1.default.FAIL;
        }
        // Without Scoring
        else {
            passStatus = PassStatus_1.default.PASS;
        }
    }
    // Grade - CALCULATED
    else if ((gradingMethod === null || gradingMethod === void 0 ? void 0 : gradingMethod.gradingMethodType) === GradingMethodType_1.default.CALCULATED) {
        const gradeCalculator = gradingCalculators.find(g => g.key === gradingMethod.gradingCalculator);
        if (gradeCalculator) {
            grade = (0, getGradeFromScoreAndCalculator_1.default)(percent, gradeCalculator);
            passStatus = grades.find(g => g.key === grade).passStatus;
        }
    }
    // Calc Immediate Fail
    if (fail)
        passStatus = PassStatus_1.default.FAIL;
    return {
        grade: grade ? grades.find(g => g.key === grade) : null,
        passStatus,
    };
};
exports.default = calcGrade;
